/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.correctifsTutos.ts
 *
 * Messages AJOUTÉS par les correctifs issus de la refonte des tutoriels du
 * 2026-10-06 (badge à l'écran, espace animateur, premium, accueil des rôles,
 * tableau de bord). Les textes MODIFIÉS restent à leur place d'origine.
 * Fusionné en dernier dans fr.ts.
 *
 * Plateforme multi-événements : aucun nom d'événement écrit en dur ; le
 * vocabulaire passe par les jetons {lex...} et {eventName}. Apostrophe
 * typographique partout (en ICU, l'apostrophe droite échappe l'accolade qui
 * la suit). Aucun tiret cadratin.
 *
 * Mikael - chef de projet - 2026-10-06
 */
export const messagesCorrectifsTutosFr: Record<string, string> = {
  // ── Mon badge : photo de profil à l'écran ──────────────────────────────
  'badge.photo.alt': 'Photo de {name}',
  // ── Mon profil : bouton de choix de la photo (plus de champ natif) ──────
  'profil.photo.choisir': 'Choisir une photo',
  'profil.photo.changer': 'Changer de photo',

  // ── Essai du contrôle d'accès (badge d'essai dans l'onglet « Contrôle
  //    d'accès ») ────────────────────────────────────────────────────────
  'scanDemo.body.acces':
    'Scannez ces badges d’essai pour découvrir le contrôle d’accès du jour J : vérifier l’inscription d’une personne à votre {lexWorkshopBare}, puis pointer sa présence.',
  'exhibitorScanner.access.essai.bandeau':
    'Essai avec une personne fictive : aucune présence n’est pointée, rien n’est enregistré.',
  'exhibitorScanner.access.essai.atelier': '{lexWorkshopCap} d’essai',

  // ── Programme : l'inscription de la personne connectée (2026-10-06) ────
  'programme.workshop.inscrit.aria': 'Inscrit·e à « {title} » : voir ou annuler mon inscription',
  'programme.workshop.attente': 'En liste d’attente',
  'programme.workshop.attente.aria': 'En liste d’attente pour « {title} » : voir ou annuler ma demande',

  // ── Encart premium de « Mon stand » : titre selon l'état ───────────────
  'premium.encart.titre.actif': 'Premium',
  'premium.encart.titre.demande': 'Demande de premium',

  // ── Entretiens : clôture et évaluation le jour J et après ──────────────
  // ── Tableau de bord : chiffres seulement, bandeau vers « Pilotage » ─────
  'dashboardLive.bandeau.aria': 'État de l’application en une ligne',
  'dashboardLive.bandeau.explication':
    'Cette page affiche les chiffres en direct, elle ne change rien. Pour ouvrir ou fermer l’application, le scan ou les inscriptions : Pilotage.',
  'dashboardLive.bandeau.piloter': 'Piloter',
  'etatApp.ligne.acces.open': 'Ouvert au public',
  'etatApp.ligne.acces.exhibitor_only': 'Réservé aux {lexExhibitorPlural} et aux animateurs',
  'etatApp.ligne.acces.maintenance': 'Application fermée (maintenance)',
  'etatApp.ligne.scan.ouvert': 'scan réel ouvert',
  'etatApp.ligne.scan.ferme_jusqua': 'scan réel fermé jusqu’au {quand}',
  'etatApp.ligne.scan.ferme': 'scan réel fermé',
  'etatApp.ligne.alertes.aucune': 'aucune alerte',
  'etatApp.ligne.alertes': '{n, plural, one {# alerte : voir Pilotage} other {# alertes : voir Pilotage}}',

  // ── Pilotage : étape en tête, actions, détail, aperçus repliés ──────────
  'pilotage.etape.sens.custom':
    'Les verrous ont été réglés un par un : aucune étape prédéfinie ne correspond exactement. Le détail plus bas dit ce qui est ouvert.',
  'pilotage.etape.auto.prochain':
    'L’étape avant, pendant ou après {eventTypeDef} change seule : elle passera à « {vers} » le {quand}. Vous n’avez rien à faire.',
  'pilotage.etape.auto.forcee':
    'L’étape avant, pendant ou après est forcée sur « {forcee} ». Remettez « Automatique » dans les actions ci-dessous pour qu’elle change seule.',
  'pilotage.etape.auto.aucun':
    'L’étape avant, pendant ou après change seule selon les dates ; il n’y a plus de changement à venir.',
  'pilotage.actions.titre': 'Ce que vous pouvez faire',
  'pilotage.detail.titre': 'Détail : ce que l’application fait en ce moment',
  'pilotage.apercu.titre': 'Voir l’application comme… (n’affecte que votre écran)',
  'pilotage.apercu.texte':
    'Ces boutons changent seulement ce que VOUS voyez, dans ce navigateur, pour vérifier un écran. Ils n’ouvrent ni ne ferment rien pour les autres et n’enregistrent aucun réglage.',

  // ── Activation d'un membre de l'équipe de scan (lien profil=equipe) ────
  'acceptInvitation.subtitle.equipe':
    'Bienvenue dans l’équipe de {eventName}. Choisissez un mot de passe pour activer votre compte : vous scannerez ensuite les badges avec l’application.',
  'acceptInvitation.footnote.equipe':
    'Pour scanner, ouvrez l’application sur votre téléphone et connectez-vous avec votre adresse électronique : un code à 6 chiffres vous est envoyé, sans mot de passe.',

  // ── Exposants : règle unique de comptage (liste et export) ──────────────
  'exhibitorsAdmin.kpi.exposants': '{lexExhibitorPluralCap}',
  'exhibitorsAdmin.kpi.animateurs': 'Animateurs {lexWorkshopOfPluralBare}',
  'exhibitorsAdmin.comptage.aria': 'Pourquoi les nombres de comptes et de fiches diffèrent',
  'exhibitorsAdmin.ecart.fiche_sans_compte':
    '{n, plural, one {# fiche sans compte propriétaire} other {# fiches sans compte propriétaire}}',
  'exhibitorsAdmin.ecart.compte_plusieurs_fiches':
    '{n, plural, one {# compte porte plusieurs fiches} other {# comptes portent plusieurs fiches}}',
  'exhibitorsAdmin.ecart.fiches_en_trop':
    '{n, plural, one {soit # fiche de plus que de comptes} other {soit # fiches de plus que de comptes}}',
  'exhibitorsAdmin.ecart.compte_sans_fiche':
    '{n, plural, one {# compte {lexExhibitorBare} sans fiche} other {# comptes {lexExhibitorBare} sans fiche}}',
  'exhibitorsAdmin.ecart.animateur_avec_fiche':
    '{n, plural, one {# animateur porte aussi une fiche, compté dans les deux nombres} other {# animateurs portent aussi une fiche, comptés dans les deux nombres}}',
  'exhibitorsAdmin.ecart.recruteur_avec_fiche':
    '{n, plural, one {# compte recruteur porte sa propre fiche} other {# comptes recruteurs portent leur propre fiche}}',
  'exhibitorsAdmin.ecart.comptes_recruteurs':
    '{n, plural, one {# compte recruteur rattaché à une fiche, non compté comme {lexExhibitorBare}} other {# comptes recruteurs rattachés à une fiche, non comptés comme {lexExhibitorPlural}}}',
  'exhibitorsAdmin.doublons':
    '{n, plural, one {# adresse portée par deux comptes ou deux fiches : repère « doublon possible » dans la liste. Aucune fusion automatique ; l’outil de fusion ne traite pas ces comptes, à vérifier à la main.} other {# adresses portées par deux comptes ou deux fiches : repère « doublon possible » dans la liste. Aucune fusion automatique ; l’outil de fusion ne traite pas ces comptes, à vérifier à la main.}}',
  'exhibitorsAdmin.badge.doublon': 'Doublon possible',
  'exhibitorsAdmin.badge.doublon.aide': 'Même adresse que d’autres comptes ou fiches : {email}',

  // ── Remise des cadeaux : confirmation après « Remis » ──────────────────
  'cadeaux.verif.remisConfirme': 'Remis : {lot}',

  // ── Tableau de bord : un point de remise compte des lots remis ─────────
  'controlStatsCompact.lotsRemis': '{count, plural, one {lot remis} other {lots remis}}',

  'entretiens.onglet.cloture.pasEncore':
    '« Terminé », « Absent » et l’évaluation se font le jour de l’événement ou après.',
};
